import { Doc } from '@dadohr/shared/domainTypes/document';
import { IUser } from '@dadohr/shared/domainTypes/user';
import { Typography } from '@material-ui/core';
import { compact } from 'lodash';
import { Link } from 'react-router-dom';
import { useRoutes } from '../../routes';
import { toFullName, useUserById } from '../../services/user';

export const LazyUserById: React.FC<{
  userId: string;
  otherUsers?: { [id: string]: Doc<IUser> };
  includeLinkToUserProfile?: boolean;
  emptyDefault?: React.ReactNode;
  prefix?: string;
  suffix?: string;
}> = ({
  userId,
  otherUsers = {},
  includeLinkToUserProfile,
  emptyDefault = null,
  prefix = null,
  suffix = null
}) => {
  const { ROUTES } = useRoutes();
  const [user] = useUserById(userId);
  const u = otherUsers[userId] || user || null;
  if (!u) {
    return <>{emptyDefault}</>;
  }
  const text = compact([prefix, toFullName(u.data), suffix]).join(' ');
  if (includeLinkToUserProfile) {
    return (
      <Typography color="primary">
        <Link to={ROUTES.users.profile.url(userId)}>{text}</Link>
      </Typography>
    );
  }
  return <Typography>{text}</Typography>;
};
